<template>
  <div class="consumer-success">
    <div class="row success-instructions" v-if="consumerLoaded">
      <div class="col-12" v-if="submits.length > 0">
        <div class="col-12" v-if="hasContentInfos">
          <div class="col-12" >
            <h2 v-html="SuccessTitle"></h2>
          </div>
          <div class="col-12" v-html="SuccessText"></div>
        </div>
        <div class="col-12" v-else>
          <h2>What's next?</h2>
          <ul>
            <li>
              A representative from each school listed will contact you.
            </li>
            <li>
              They will provide information about the program you're interested in.
            </li>
            <li>
              Choose the school that's right for you!
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12" v-else>
        <div class="col-12" v-if="hasContentInfos">
          <div class="col-12">
            <div class="col-12" >
              <h4 v-html="noOfferSubmittesContentTitle"></h4>
            </div>
            <div class="col-12" v-html="noOfferSubmittesContentText"></div>
          </div>
        </div>
        <div class="col-12" v-else>
          <h4>No offers submitted</h4>
        </div>
      </div>
    </div>
    <div class="row success-lists" v-if="consumerLoaded && submits.length > 0">
      <div class="col-4">
        <AcceptedOffers :title="'Accepted Schools'" :is-extra="false"></AcceptedOffers>
      </div>
      <div class="col-4" v-if="hasExtraAccepted">
        <AcceptedOffers :title="'Accepted Extra Offers'" :is-extra="true"></AcceptedOffers>
      </div>
      <div class="col-4">
        <RejectedOffers :title="'Rejected Schools'"></RejectedOffers>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import AcceptedOffers from '@/components/offer-minilists/AcceptedOffers.vue'
import RejectedOffers from '@/components/offer-minilists/RejectedOffers.vue'

export default {
  name: 'ConsumerSuccess',
  props: ['consumerId'],
  data () {
    return {
    }
  },
  components: {
    AcceptedOffers,
    RejectedOffers
  },
  methods: {
    load (id) {
      if (!this.consumerLoaded || this.loadedId !== id) {
        this.loadConsumer(id)
      }
    },
    mapText (text) {
      const leadFields = [['__consumer_phone__', 'phone1'],
        ['__consumer_name__', 'fullname'],
        ['__consumer_email__', 'email'],
        ['__consumer_firstname__', 'firstname'],
        ['__consumer_lastname__', 'lastname'],
        ['__agent_id__', 'agent_id'],
        ['__agent_name__', 'agent_name'],
        ['__call_center_dba__', 'call_center_dba'],
        ['__consumer_address__', 'address'],
        ['__consumer_city__', 'city'],
        ['__consumer_state__', 'state'],
        ['__consumer_zip__', 'zip']]

      if (this.leadInfo) {
        leadFields.forEach((item) => {
          text = text.replace(new RegExp(item[0], 'g'), this.leadInfo[item[1]] ?? '')
        })
      }
      return text
    },
    ...mapActions({
      loadConsumer: 'consumer/retrieveConsumer'
    })
  },
  computed: {
    hasExtraAccepted () {
      return this.submits.some((offer) => offer.status === 'Accepted' && offer.offer.isExtra)
    },
    hasContentInfos () {
      return this.contentTextInfos.length > 0
    },
    SuccessTitle () {
      return this.mapText(this.contentTextInfos[0].success_page_title)
    },
    SuccessText () {
      return this.mapText(this.contentTextInfos[0].success_page_body)
    },
    noOfferSubmittesContentTitle () {
      return this.mapText(this.contentTextInfos[0].no_offer_submitted_page_title)
    },
    noOfferSubmittesContentText () {
      return this.mapText(this.contentTextInfos[0].no_offer_submitted_page_body)
    },
    ...mapState({
      loadedId: state => state.consumer.consumerId,
      contentTextInfos: state => state.consumer.contentTextInfos
    }),
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded',
      submits: 'consumer/leadRequests/getRequests',
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  mounted () {
    if (this.consumerId) {
      this.load(this.consumerId)
    }
  },
  watch: {
    consumerId (val) {
      this.load(val)
    }
  }
}
</script>
